import { Component, OnInit, ViewChild } from '@angular/core';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { WorkflowAutoUploadService } from 'app/services/workflow-auto-upload.service';
import { WorkflowAutoEmailService } from 'app/services/workflow-auto-email.service';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { FormGroup } from '@angular/forms';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
  selector: 'app-custom-automated-actions',
  templateUrl: './custom-automated-actions.component.html',
  styleUrls: ['./custom-automated-actions.component.scss']
})
export class CustomAutomatedActionsComponent implements OnInit {

  constructor(public workflowWizardService: WorkflowWizardService, private _route: Router, private activatedRoute: ActivatedRoute,
    private _saveRulesService: WorkflowAutoUploadService, private _emailRulesService: WorkflowAutoEmailService, private ecoDocsTitleService: EcoDocsTitleService
  ) {
  }

  ngOnInit() {
    this.ecoDocsTitleService.setTitle( 'Workflow Wizard > Post-step Auto-Actions' , false);

    if (this.workflowWizardService.currentId == 'new') {
      if (this.workflowWizardService.currentStepURL != this.workflowWizardService.WIZARD_NEW_STEP_RULES) {
        this._route.navigate([this.workflowWizardService.baseURL + this.workflowWizardService.WIZARD_FIRST_STEP]);
      }
    } else {
      if (!this.workflowWizardService.currentStep) {
        if (this.activatedRoute.snapshot.params.stepid && this.activatedRoute.snapshot.params.stepid != 'new') {
          // find current step by ID
          this.workflowWizardService.currentStep = this.workflowWizardService.findStepById(+this.activatedRoute.snapshot.params.stepid);
        }

        if (!this.workflowWizardService.currentStep) {
          this.workflowWizardService.currentStepURL = this.workflowWizardService.WIZARD_STEPS_TREE;
          this._route.navigate([`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_STEPS_TREE}`]);
          return;
        }
      }
    }
  }


  onClickNext() {
    this.workflowWizardService.updateAllValueAndValidity();

    if (this.workflowWizardService.workflowType == 'custom') {
      this._route.navigate([`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_STEPS_TREE}`]);
    }
    else {
      this.workflowWizardService.saveWorkflowTemplate().subscribe(()=>{
        this._route.navigate(['workflows/templates']);
      });
    }
  }

  saveAndPublish() {
    this.workflowWizardService.saveWorkflowTemplate().subscribe(()=>{
      this.workflowWizardService.publishWorkflowTemplate().subscribe(()=>{
        this._route.navigate(['workflows/templates']);
      });
    });
  }
  
  back() {
    this.workflowWizardService.currentStepURL = this.workflowWizardService.WIZARD_NEW_STEP;
    this._route.navigate([`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_NEW_STEP}`]);
  }
}
